import { CHANGE_FIELD } from "./actionsType";

export const changeField = (field,field_value) => {
   return {
      type: CHANGE_FIELD,
      field: field,
      field_value: field_value
   }
}